import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import VueCookies from 'vue3-cookies';
import BootstrapVue3 from 'bootstrap-vue-3';
import Vue3Toasity, { type ToastContainerOptions } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
//import { FontAwesomeIcon } from './plugins/font-awesome'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)
import VueClipboard from 'vue-clipboard2'
import VueLazyLoad from 'vue3-lazyload'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

VueClipboard.config.autoSetContainer = true;

const app = createApp(App);

app.config.warnHandler = (msg, vm, trace) => {
    if (msg.includes('Failed to resolve component: v')) {
        return;  // ��� �޽��� ����
    }
    //console.warn(msg, vm, trace);
};

app.use(store)
app.use(router)
app.use(BootstrapVue3)
app.use(VueCookies)
app.use(
        Vue3Toasity,
        {
            autoClose: false,
            // ...
        } as ToastContainerOptions,
    )
    //.use(new VueSocketIO({
    //    debug: true,
    //    connection: 'http://localhost:3000/',
    //    vuex: {
    //        store,
    //        actionPrefix: 'SOCKET_',
    //        mutationPrefix: 'SOCKET_'
    //    },
    //    options: { path: "/my-app/" } //Optional options
    //}))
app.component("font-awesome-icon", FontAwesomeIcon)
app.use(VueLazyLoad, {
    loading: '/loading.png',
    error: '/error.png'
})
app.use(VueClipboard)
app.use(ElementPlus)

router.isReady().then(() => {
    app.mount('#app');
});